/*
 * filename: routers.js
 * mainly responsivle for all routes component
 * change and sidebar routlist menu item
 * */

import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Drawer from 'material-ui/Drawer';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Footer from '../components/footer.js';
import RoutesComponent from './routesComponent.js';
import RoutesList from './routesList.js';
import RoutesListPatientPortal from './routesListPatientPortal';
import RoutesListSuperadmin from './routesListSuperadmin';
import { Scrollbars } from 'react-custom-scrollbars';
import ScrollUpButton from 'react-scroll-up-button';
import StyleSwitcher from '../style-switcher/index.js';
import LogoImageViewer from '../components/logoImageViewer';


class Main extends Component {
  constructor() {
    super();
    this.state = { menuOpen: true };
    this.menuCollapseWithResize = this.menuCollapseWithResize.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleCloseMenu = this.toggleCloseMenu.bind(this);
  }

  // menu collapse when on mobile function
  menuCollapseWithResize() {
    if (window.innerWidth < 991) {
      this.setState({ menuOpen: false });
    }
    if (window.innerWidth > 991) {
      this.setState({ menuOpen: true });
    }
  }

  // Sidebar collapse when tablet
  componentDidMount() {

    window.addEventListener('resize', this.menuCollapseWithResize);

    if (window.innerWidth < 991) {
      this.setState({ menuOpen: false });
    }

  }

  // Sidebar collapse when tablet
  componentWillUnmount() {
    window.removeEventListener('resize', this.menuCollapseWithResize);
  }

  // Sidebar toggle
  toggleMenu() {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  }

  toggleCloseMenu() {
    if (window.innerWidth < 991) {
      this.setState({ menuOpen: false });
    }
  }

  render() {
    const headerStyle = {
      background: this.props.colorHeader.color,
    };

    const containerStyle = {
      background: this.props.colorSidebar.color,
    };

    const headersm = classNames({
      'menu-open2': this.state.menuOpen,
    });

    // Page content class change based on menu toggle
    const pageContent = classNames({
      'readmin-page-content': true,
      'menu-open': this.state.menuOpen,
    });

    // Sidebar class based on bg color
    const sidebarClass = classNames({
      'menu-drawer': true,
      'has-bg': true,
    });

    // header left part with logo and toggle button
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    const HeaderLogoWithMenu = () => (
      <div className={headersm}>
        <div className="an-header" style={headerStyle}>
          <div className="header-left">
            <a className="brand" href="">
            <LogoImageViewer isLoginPage={false} logoUrl={logoUrl} businessName={this.props.businessName} />              
            </a>
            {/* {this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERADMIN' ?
            <a className="brand" href=""><img src={LoginLogo} alt="" /></a> 
            :            
            <a className="brand" href="">
              {this.props.organizationDetails && this.props.organizationDetails.logoBase64 ? 
              <img src={'data:image/png;base64,' + this.props.organizationDetails.logoBase64} alt="" />
              :
              <img src={LoginLogo} alt="" />}
            </a>
            } */}
            <FloatingActionButton
              mini={true}
              secondary={true}
              onClick={this.toggleMenu}
            >
              <i className="material-icons">format_indent_decrease</i>
            </FloatingActionButton>
          </div>
        </div>
      </div>
    );

    return (
      <div className="hgt100">
        {this.props.loginUserInfo ?
          <div className="readmin-sidebar">
            <HeaderLogoWithMenu />
            <Drawer
              open={this.state.menuOpen}
              className={sidebarClass}
              containerClassName="sidebar-initial-color"
              containerStyle={containerStyle}
            >
              <Scrollbars>
                {this.props.loginUserInfo.users3 && this.props.loginUserInfo.users3.userRoles.roleName === 'Client' ?
                  <RoutesListPatientPortal
                    patientInfo={this.props.patientInfo}
                    patientMenuShowStatus={this.props.patientMenuShowStatus}
                    userInfo={this.props.userInfo}
                    userMenuShowStatus={this.props.userMenuShowStatus}          
                    toggleCloseMenu={this.toggleCloseMenu} />
                  :
                  (this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERADMIN' || this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERUSER') ?
                    <RoutesListSuperadmin
                      patientInfo={this.props.patientInfo}
                      patientMenuShowStatus={this.props.patientMenuShowStatus}
                      userInfo={this.props.userInfo}
                      userMenuShowStatus={this.props.userMenuShowStatus}          
                      toggleCloseMenu={this.toggleCloseMenu} />
                    :                    
                    <RoutesList
                      patientInfo={this.props.patientInfo}                      
                      patientMenuShowStatus={this.props.patientMenuShowStatus}
                      userInfo={this.props.userInfo}
                      userMenuShowStatus={this.props.userMenuShowStatus}                      
                      userPermissions={this.props.userPermissions}
                      loginUserInfo={this.props.loginUserInfo}
                      toggleCloseMenu={this.toggleCloseMenu} />
                }
              </Scrollbars>
            </Drawer>
          </div>
          : null}

        {this.props.loginUserInfo ?
          <div
            className={pageContent}>

            {this.props.clientListPermission && this.props.loginUserInfo.users3 && this.props.loginUserInfo.users3.userRoles.roleName !== 'Client' ?
              <StyleSwitcher />
              :
              null
            }
            <div className="content_page">

              <RoutesComponent {...this.props} loginUserInfo={this.props.loginUserInfo} userPermissions={this.props.userPermissions} />
            </div>
            <Footer />
          </div>
          :
          <RoutesComponent />
        }
        <div className="scrollbtn">
          <ScrollUpButton />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {

  // //  // Start For Role Permission
  // let userModulePermission = [];
  // if (state.login.userPermission) {
  //   userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT') ;
  // }

  // let IsAdminLoggedIn = state.login.loginUserInfo && state.login.loginUserInfo.users3 && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  // let clientListPermission = userModulePermission && userModulePermission.length ?
  //   IsAdminLoggedIn ? true : userModulePermission.filter((obj) => obj.moduleKey === 'CLIENT')[0].permission : IsAdminLoggedIn;

  // End For Role Permission

  // Start For Role Permission  
  let userScreenPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    //userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3 && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let clientListPermission = hasDefaultAccess ? true : userScreenPermission && userScreenPermission.length ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_VIEW_CLIENT')[0].permission : false;
  // End For Role Permission

  return {
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    patientInfo: state.patient.patientInfo,    
    patientMenuShowStatus: state.patient.patientMenuShowStatus,
    userInfo: state.user.userInfo,
    userMenuShowStatus: state.user.userMenuShowStatus,
    colorHeader: state.headerActiveStyle,
    colorSidebar: state.sidebarActiveStyle,
    access_token: state.login.access_token,
    loginUserInfo: state.login.loginUserInfo,
    userPermissions: state.login.userPermission,
    isPatientLoading: state.patient.loading || state.patient.loadingMasterData || state.patient.loadingAuthDataList,
    isSchedulingLoading: state.scheduling.loading || state.nonBillableSoap.loading || state.soap.loading || state.scheduling.loadingAppointmentList,
    isClearingHouseLoading: state.clearing_house.loading,
    isManage_ERA_Loading: state.Manage_ERA_Reducer.loading,
    isServiceCodeLoading: state.service_code.loading,
    // isMasterLoading: state.master.loading,
    isBillingLoading: state.billing.loading,
    isLocationMasterLoading: state.location_master.loading,
    isRoundingRuleLoading: state.rounding_rule.loading || state.rounding_rule.saving,
    isCustomFieldLoading: state.custom_field.loading,
    isManageTagLoading: state.manage_tag.loading,
    isManagePayerLoading: state.payer.loading,
    patientPortalLoading: state.patientPortal.loading,
    isAppConfigLoading: state.appConfig.loading,
    // isManageRoleLoading: state.role.loading || state.rolePermission.loading,
    isDiagnosisCodeLoading: state.diagnosisCode.loading,
    isAppointmentTypeLoading: state.appointment_type.loading,
    isAgencyLoading: state.agency.loading,
    isSuperadminReportLoading: state.superadminReport.loading,    
    islogsLoading: state.logs.loading,
    isUserReducerLoading: state.user.loading,
    isUserRoleLoading: state.userRoles.loading,
    isInsuranceTypeLoading: state.insuranceType.loading,
    isNoteTypeLoading: state.noteType.loading,
    isSecurityQuestionsReducerLoading: state.security_questions.authenticating,
    isMasterSecurityQuestionLoading: state.mastersecurityQuestions.loading,
    isMasterDocumentTypesLoading: state.masterDocumentTypes.loading,
    isMasterDocumentTypesStaffLoading: state.masterDocumentTypesStaff.loading,
    isRolePermissionsLoading: state.rolePermissions.loading,
    isSuperAdminLoadinig: state.superadminLogin.authenticating,
    isSuperAdminClearingHouseLoading: state.superAdminClearingHouse.loading,
    clientListPermission: clientListPermission,
    manageDatabaseLoading: state.manageDatabase.loading,
    organizationDetails: state.login.organizationDetails,
    isLedgerLoading: state.ledger.loading,
    isMasterTherapyLoading: state.masterTherapy.loading,    
    isManageAppointmentsLoading: state.manageAppointments.loading,
    isPatientManageAppointmentsLoading: state.patient_manageAppointments.loading,
    isPatientDataCollectionGraphLoading: state.patient_dataCollectionGraph.loading,
    isMasterClinicalRoomLoading: state.masterClinicalRoom.loading,
    isReportLoading: state.report.loading,    
    /* #region  Data Collection */ 
    isCurriculumLibraryLoading: state.curriculumLibraries.loading,
    isMaintenanceLevelLoading: state.maintenanceLevels.loading,
    isPromptCodeLoading: state.prompt_code.loading,
    isBehaviorCategoryLoading: state.behaviorCategory.loading,
    isSkillAcquisitionDomainLoading: state.skillAcquisitionDomain.loading,
    isSkillAcquisitionProgramLoading: state.skillAcquisitionProgram.loading,
    isSkillAcquisitionTargetLoading: state.skillAcquisitionTarget.loading,
    isDailySummaryDataLoading : state.patientDailySummaryData.loading,
    isPatientPromptCodeLoading: state.patient_prompt_code.loading,
    isPatientMasterCriteriaLoading: state.patient_masterCriteria.loading,
    isPatientGeneralSettingsLoading: state.patient_generalSettings.loading,    
    isPatientdefaultPhaseChangeLinesLoading: state.patient_defaultPhaseChangeLines.loading,    
    isPatientBehaviorLoading: state.patient_behavior.loading,
    isPatientAntecedentsLoading: state.patient_antecedents.loading,    
    isPatientConsequencesLoading: state.patient_consequences.loading,
    isPatientLocationsLoading: state.patient_locations.loading,
    isPatientRawABCDataLoading: state.patient_rawABCData.loading,
    
    isPatientNotesLoading: state.patient_notes.loading,
    ispatientSkillAcqProgramLoading: state.patientSkillAcqActiveProgram.loading,
    ispatientSkillAcqTargetLoading: state.patientSkillAcqActiveTarget.loading,
    isPatientBehaviourDataLoading: state.patientBehaviourData.loading,
    isPatientBehaviourRecordRateLoading: state.patientRecordRateCustomReducer.loading,
    isPatientBehaviourRecordIntervalLoading: state.patientRecordIntervalCustomReducer.loading,
    isPatientBehaviourRecordMomentaryLoading: state.patientRecordMomentaryCustomReducer.loading
    /* #endregion */
  };
}

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/routers/main.js